import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { IoPhonePortraitOutline } from "react-icons/io5";
import { LuCircleCheckBig } from "react-icons/lu";
import Phone from "../../assets/images/phone-app.png";
import ReactPlayer from "react-player";
import "./AppDownload.css";

export default function AppDownload(props) {
  return (
    <div>
      <Container>
        <Row>
          <Col className="app-download-first-col">
            <h2 style={{ color: props.titleColor, fontSize: props.titleSize }}>
              <IoPhonePortraitOutline
                style={{ color: props.iconColor }}
                className="app-download-icon"
              />
              BAIXE NOSSO APLICATIVO
            </h2>
          </Col>
        </Row>
      </Container>
      <Container
        fluid
        style={{ background: props.lightBG }}
        className="app-download-container"
      >
        <Container>
          <Row>
            <Col lg={4} className="app-download-second-col">
              <h4
                style={{
                  color: props.subTitleColor,
                  fontSize: props.subTitleSize,
                }}
              >
                Acesso facilitado a
              </h4>
              <div className="app-download-second-itens">
                <div className="app-download-second-item">
                  <LuCircleCheckBig
                    style={{ color: props.iconColor }}
                    className="app-download-item-icon"
                  />
                  <p
                    style={{ color: props.textColor, fontSize: props.textSize }}
                  >
                    Informações do seu plano
                  </p>
                </div>
                <div className="app-download-second-item">
                  <LuCircleCheckBig
                    style={{ color: props.iconColor }}
                    className="app-download-item-icon"
                  />
                  <p
                    style={{ color: props.textColor, fontSize: props.textSize }}
                  >
                    Emissão de boletos
                  </p>
                </div>
                <div className="app-download-second-item">
                  <LuCircleCheckBig
                    style={{ color: props.iconColor }}
                    className="app-download-item-icon"
                  />
                  <p
                    style={{ color: props.textColor, fontSize: props.textSize }}
                  >
                    Lista de todos os nossos parceiros da Rede de Vantagens
                  </p>
                </div>
              </div>
              <div className="app-download-second-link">
                <a
                  href="https://play.google.com/store/apps/details?id=br.com.grupokrause&hl=pt_BR"
                  rel="noopener noreferrer"
                  className="app-link-google"
                >
                  {" "}
                </a>
                <a
                  href="https://apps.apple.com/br/app/grupo-krause/id1659309394"
                  rel="noopener noreferrer"
                  className="app-link-apple"
                >
                  {" "}
                </a>
              </div>
            </Col>
            <Col lg={4} className="app-phone-container">
              <img
                src={Phone}
                alt="Aplicativo no celular"
                className="app-phone-img"
              />
            </Col>
            <Col lg={4} className="app-download-third-col">
              <h4
                style={{
                  color: props.subTitleColor,
                  fontSize: props.subTitleSize,
                }}
              >
                Veja como instalar o app
              </h4>
              <ReactPlayer
                style={{
                  width: "50%",
                  height: "100%",
                }}
                controls={true}
                src="https://youtube.com/shorts/W8m5z86j0Us?si=ClPS2YWNoD8J3wZ8"
              />
            </Col>
          </Row>
        </Container>
      </Container>
    </div>
  );
}
